import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import { trackConsultation, trackConsultationBookingComplete } from "@/lib/analytics";

const CALENDLY_URL = process.env.REACT_APP_CALENDLY_URL || "https://calendly.com/korewellbeing-info/30min";

// Inline Calendly widget matching Kore brand palette.
// Use inside a card/section — parent controls the outer chrome.
// `bookingType` is passed to `book_consultation` when Calendly posts back a
// genuine event_scheduled message (i.e. only when a slot is actually booked).
export default function CalendlyEmbed({ prefill = {}, utm = {}, height = 720, minWidth = 320, bookingType = "consultation" }) {
  useCalendlyEventListener({
    onEventScheduled: () => {
      trackConsultation({ booking_type: bookingType });
      trackConsultationBookingComplete({ booking_type: bookingType });
    },
  });
  return (
    <div data-testid="calendly-embed" className="w-full">
      <InlineWidget
        url={CALENDLY_URL}
        prefill={prefill}
        utm={utm}
        styles={{ height: `${height}px`, minWidth: `${minWidth}px` }}
        pageSettings={{
          backgroundColor: "faf7f2",
          primaryColor: "1f3a2e",
          textColor: "1a1a1a",
          hideEventTypeDetails: false,
          hideLandingPageDetails: false,
          hideGdprBanner: true,
        }}
      />
    </div>
  );
}
